import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  status: {
    display: 'flex',
    justifyContent: 'flex-start',
  },

  correct: {
    marginLeft: 8, 
    border:'1px solid #00c853', 
    color:  '#00c853',
    backgroundColor: '#e6ffed',
    width: '130px',
    fontSize: '0.7rem',
    padding: '0 5px',
  },

  wrong: {
    marginLeft: 8, 
    border:'1px solid #d32f2f', 
    color:  '#d32f2f', 
    width: '130px',
    backgroundColor: '#ffe6e6',
    fontSize: '0.7rem',
    padding: '0 5px',
  },
}));

